import { useCroptimizer } from 'features/Croptimizer/providers/CroptimizerContext';
import { FieldProps } from 'features/Croptimizer/types';
import { Metric } from 'utils/constants';
import { CropProps } from 'utils/types';
import {
  cmToFineDry,
  HaToacOnly, unMaskInput, unMaskInputValue,
} from 'utils/helpers';

import { useGenerateCrop } from './useGenerateCrop';

export const useResetData = (currentCrop: CropProps) => {
  const { boardSoilValues, boardStatusValues, setFields, metricValue } = useCroptimizer();
  const { generateCrop } = useGenerateCrop();

  const resetData = (id: number) => () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    setFields((prevFields: FieldProps[]) => prevFields.map((field) => {
      if (field.id === id) {
        const object = {
          soilTypeI: boardSoilValues?.soilType ?? '',
          secI: boardSoilValues?.secsmol ?? '',
          currentphI: unMaskInputValue(boardStatusValues?.currentPh || '5,8'),
          currentSecI: boardStatusValues?.currentSec ?? '',
          targetphI: unMaskInputValue(boardStatusValues?.targetPh || '6,3'),
          targetSecI: boardStatusValues?.targetSec ?? '',
          productTypeI: boardSoilValues?.productName ?? '',
          nvI: boardSoilValues?.nv ?? '',
          mtI: boardSoilValues?.mt ?? '',
          fineAndDry: cmToFineDry(Number(unMaskInput(boardSoilValues?.fineDrySoil || '20'))),
          areaI: unMaskInputValue(
            metricValue === Metric.metric ? '10' : String(HaToacOnly(10)),
          ),
        };

        return {
          id,
          title: '',
          object: {
            ...object,
            tableDataI: [generateCrop(currentCrop, object)],
          },
        };
      }

      return field;
    }),
    );
  };

  return {
    resetData,
  };
};